import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'merchantCategory', filter),
  get: (id) => Ajax('get', `merchantCategory/${id}`),
  add: (data) => Ajax('post', 'merchantCategory', data),
  edit: (id, data) => Ajax('put', `merchantCategory/${id}`, data),
  delete: (id) => Ajax('delete', `merchantCategory/${id}`),
};
